import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { UrlService } from "../../core/services/UrlService";
import "./footer.scss"

export const FooterLogo = () => {
    return (
        <div>
            <img className="logo" src={UrlService.getImageUrl('logo-white.png')} srcSet={`${UrlService.getImageUrl('logo-white.png')} 1x, ${UrlService.getImageUrl('logo-white@2x.png')} 2x, ${UrlService.getImageUrl('logo-white@3x.png')} 3x`} alt="" />
            <p className="footer__slogan">
                {/* { t('footer.slogan') } */}
                隨時隨地約見您的醫生
            </p>
        </div>
    );
};

const Footer = () => {
    const localeUrlPrefix = "";
    const socialMediaSprite = UrlService.getImageUrl('social-medias/sprite-white.svg');

    return (
        <footer>
            <div className="footer-container footer-container--desktop container">
                <div className="row flex-column flex-lg-row footer__bottom">
                    <div className="footer__copy">
                        <FooterLogo />
                        <p className="footer__copyright pt-0">
                            <span>
                                {/* { t('footer.copyright.1')} */}
                                FindDoc 不會提供任何形式的醫療建議、診斷或診治。
                            </span>
                            <span>
                                版權所有 © {new Date().getFullYear()} FindDoc
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="footer-container footer-container--mobile container">
                <div className="footer__mobile-logo">
                    <FooterLogo />
                    <p className="footer__copyright pt-0">
                        <span>FindDoc 不會提供任何形式的醫療建議、診斷或診治。</span>
                        <br></br>
                        <span>版權所有 © {new Date().getFullYear()} FindDoc</span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
